<script>
  import { langTextStore } from "../store/langtexts.js";
  export let date;
  var actualDate = new Date(date);
  var options = {
    weekday: "short",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  // returns "Wed, 22 April 2015"
</script>

{actualDate.toLocaleTimeString($langTextStore.locale, options)}
